import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "./sub-footer.css";
import { ImFacebook } from "react-icons/im";
import { FaLinkedinIn } from "react-icons/fa";
import { BsTwitter } from "react-icons/bs";

let SubFooter = () => {
  return (
    <div className="sub-footer-container">
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
            <div className="sub-footer-copyright-main">
              <p className="sub-footer-copyright">
                ©2022 Amafclasses private ltd. all rights reserved
              </p>
            </div>
          </Grid>
          <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
            <div className="sub-footer-social-button-main">
              <button className="sub-footer-social-button">
                <ImFacebook color="#663399" size={20} />
              </button>
              <button className="sub-footer-social-button">
                <FaLinkedinIn color="#663399" size={20} />
              </button>
              <button className="sub-footer-social-button">
                <BsTwitter color="#663399" size={20} />
              </button>
            </div>
          </Grid>
          <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
            <div className="sub-footer-terms-services-main">
              <button className="sub-footer-terms-button">terms of service</button>
              <button className="sub-footer-privacy-button">
                privacy policy
              </button>
            </div>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};
export default SubFooter;
